const GUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Filtro pointOfSaleIds del link per le API multi-store: solo GUID validi, senza spazi
// e senza doppioni. Senza id validi il filtro si omette (il backend non filtra).
export const normalizeFilterPointOfSaleIds = (
  list?: string[]
): string[] | undefined => {
  const ids = Array.from(
    new Set((list ?? []).map((id) => id.trim()).filter((id) => GUID.test(id)))
  );
  return ids.length > 0 ? ids : undefined;
};
